/**
 * Custom Hook for Authentication
 * Provides authentication state and helper functions
 */

import { useNavigate } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import { storage, STORAGE_KEYS } from "../config/appConfig";

export const useAuth = () => {
  const navigate = useNavigate();

  const getUser = () => {
    return storage.get(STORAGE_KEYS.USER) || {};
  };

  const getToken = () => {
    return storage.getString(STORAGE_KEYS.TOKEN);
  };

  const isAuthenticated = () => {
    return !!getToken();
  };

  const setAuthData = (token, user) => {
    storage.setString(STORAGE_KEYS.TOKEN, token);
    storage.set(STORAGE_KEYS.USER, user);
  };

  const clearAuthData = () => {
    storage.remove(STORAGE_KEYS.TOKEN);
    storage.remove(STORAGE_KEYS.USER);
  };

  const signOut = () => {
    clearAuthData();
    navigate(ROUTES.SIGN_IN);
  };

  return {
    getUser,
    getToken,
    isAuthenticated,
    setAuthData,
    clearAuthData,
    signOut,
  };
};
